import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=4ca33a60&"
import script from "./VideoBackground.vue?vue&type=script&lang=ts&"
export * from "./VideoBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports